/**
 * @file AdUnitRowSlot.tsx
 *
 * @fileoverview Renders row ad unit.
 *  This ad banner occupied the full width.
 */

interface AdUnitRowSlotProps {
  row: {
    bundle?: string;
    adUnitId?: string;
  };
}

export default function AdUnitRowSlot({
  row: { bundle, adUnitId },
}: AdUnitRowSlotProps) {
  return <></>;
}

export { AdUnitRowSlot };
